export const env = window.location.hostname
  .toLowerCase()
  .split( '.' )
  .find( function( chunk ) {
    return [ 'ci', 'dev', 'qa', 'pprd' ].indexOf( chunk ) >= 0;
  } );

function getURL( url ) {
  return url.toLowerCase().replace( '(env.)', env ? env + '.' : '' );
}

export const idURL = getURL( 'https://(env.)api.biw.cloud/v1/id' );
export const companyURL = getURL( 'https://(env.)api.biw.cloud/v1/company-service' );

export const saURL = getURL( 'https://(env.)api.biw.cloud/v1/service-awards' );
export const emailURL = getURL( 'https://(env.)api.biw.cloud/v1/emails' );
export const giftCodeURL = getURL( 'https://(env.)api.biw.cloud/v1/gift-code' );
export const companyAdminURL = getURL( 'https://(env.)company-studio.biw.cloud' );
export const giftCodeAdminURL = getURL(
  'https://(env.)gift-code-studio.biw.cloud'
);
export const imagesUrl = getURL( 'https://(env.)api.biw.cloud/v1/images/' );
export const rosterUrl = getURL( 'https://(env.)api.biw.cloud/v1/roster' );
export const videoUrl = getURL(
  'https://(env.)api.biw.cloud/v1/mtc-ingest/v1/upload-video'
);
export const cmxUrl = getURL( 'https://(env.)api.biw.cloud/v2/cmx' );
export const cashierUrl = getURL( 'https://(env.)api.biw.cloud/v1/cashier' );
export const registrationUrl = getURL(
  'https://(env.)api.biw.cloud/self-registration/services/v1'
);
